{
  "contactCustomerService": "ติดต่อฝ่ายบริการลูกค้า",
  "close": "ปิด",
  "notConfigured": "ยังไม่ได้ตั้งค่าบริการลูกค้า",
  "temporarilyUnavailable": "ไม่สามารถโหลดฝ่ายบริการลูกค้าได้ชั่วคราว",
  "retry": "ลองอีกครั้ง"
}
